import { FieldErrors, UseFormRegister } from "react-hook-form";
import type { RegisterRequestBody } from "common";
import FoundryConnectLogo from "@via/components/foundry-connect-logo.tsx";
import { Spinner } from "@via/components/loading/loading";
import { BuildingOfficeIcon } from "@heroicons/react/24/outline";
import LoginLink from "@via/components/login-link.tsx";
import React from "react";

interface EmailRegisterFormProps {
  register: UseFormRegister<RegisterRequestBody>;
  errors: FieldErrors<RegisterRequestBody>;
  isRegisterEmailLoading: boolean;
  onSubmit: (e?: React.BaseSyntheticEvent) => void;
  signUpOptions: {
    email: Record<string, unknown>;
  };
  invitationDetails: any;
}

export function EmailRegisterForm({
  register,
  errors,
  isRegisterEmailLoading,
  onSubmit,
  signUpOptions,
  invitationDetails,
}: EmailRegisterFormProps) {
  return (
    <>
      <FoundryConnectLogo />
      <div>
        <h1 className="mt-3 text-center text-2xl sm:text-3xl font-semibold text-gray-500">
          Get started with Foundry Connect 2.0
        </h1>

        {invitationDetails?.organizationName ? (
          <div className="flex justify-center items-center mt-8 gap-2 text-2xl font-semibold">
            <BuildingOfficeIcon className="w-7 h-7" />
            <h2>{invitationDetails.organizationName}</h2>
          </div>
        ) : null}
      </div>
      <div className="w-full max-w-[480px] mt-8 px-6 pb-12 pt-2">
        <form onSubmit={onSubmit}>
          <div>
            <label className="mb-1 block text-sm font-medium leading-6 text-gray-900">
              Email
            </label>
            <div className="mb-4">
              <input
                readOnly={!!invitationDetails?.invitedEmail}
                {...register("email", signUpOptions.email)}
                autoComplete="off"
                className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 duration-150 ease-in-out placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
              {errors.email && (
                <span className="text-xs text-rose-500">
                  {errors.email.message as string}
                </span>
              )}
            </div>
            <button
              type="submit"
              className="p-2 w-full flex justify-center rounded-md bg-indigo-600 text-sm font-semibold leading-6 text-white shadow-sm duration-150 ease-in-out hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              disabled={isRegisterEmailLoading}>
              <Spinner loading={isRegisterEmailLoading}>Sign up</Spinner>
            </button>
          </div>
          <div className="relative mt-14">
            <div
              className="absolute inset-0 flex items-center"
              aria-hidden="true"></div>
          </div>
        </form>
      </div>

      <LoginLink />
    </>
  );
}
